import { Box, type BoxProps } from '@mui/material';

const modules = import.meta.glob('@/assets/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

// Stable {__html} objects: React 19 re-sets innerHTML (recreating the <svg>
// node) whenever the dangerouslySetInnerHTML object identity changes, which
// breaks clicks that straddle a re-render (mousedown/mouseup on different
// nodes never produce a click).
const icons: Record<string, { __html: string }> = Object.fromEntries(
  Object.entries(modules).map(([path, raw]) => {
    const name = path.split('/').pop()!.replace(/\.svg$/, '');
    return [name, { __html: raw.replace(/#1A1A1A/gi, 'currentColor') }];
  }),
);

interface IconProps extends Omit<BoxProps, 'children'> {
  name: string;
  size?: number | string;
}

export function Icon({ name, size = 20, sx, ...rest }: IconProps) {
  const html = icons[name];
  if (!html) {
    if (import.meta.env.DEV) console.warn(`[Icon] missing icon: "${name}"`);
    return null;
  }
  return (
    <Box
      {...rest}
      sx={{
        width: size,
        height: size,
        display: 'inline-flex',
        flexShrink: 0,
        '& svg': { width: '100%', height: '100%', display: 'block' },
        ...sx,
      }}
      dangerouslySetInnerHTML={html}
    />
  );
}
